import React from 'react'
import { useSelector} from 'react-redux' 
import { Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { userlog } from '../features/auth';

const Loginprotectedroute = ({children}) => {
    const dispatch = useDispatch()
    let token = localStorage.getItem('token')
    if(token){
        dispatch(userlog(true))
    }
    const {userlogedin} = useSelector((state)=>state.auth);
    if( userlogedin){
       return <Navigate to='/' />
    }else{
        return children
    }
}

export default Loginprotectedroute
